import makers, { getServerSideProps } from './makers';
export default makers;
export { getServerSideProps };
